import classNames from 'classnames';
import React from 'react';

import Slides from 'common/components/RewindModal/Slides';

import styles from '../styles.module.scss';
import BottomActions from './component/BottomActions';

type TopGlobalSeriesIntroProps = {
  onNext: () => void;
  isLastStep: boolean;
};

const TopGlobalSeriesIntro: React.FC<TopGlobalSeriesIntroProps> = ({
  onNext,
  isLastStep
}) => {
  const title = 'Top séries';
  const subtitle =
    'Elles ont duré des saisons… ou juste un soir. En 2025, elles ont marqué tous les écrans.';

  return (
    <Slides>
      <div className={classNames(styles.contentLayout, styles.startLayout)}>
        <h2 className={styles.slideTitle}>{title}</h2>
        <h3 className={styles.slideText}>{subtitle}</h3>
      </div>
      <BottomActions
        showShare={false}
        showNext={!isLastStep}
        onNextClick={onNext}
      />
    </Slides>
  );
};

export default TopGlobalSeriesIntro;
